import { render, staticRenderFns } from "./DetailStock.vue?vue&type=template&id=7646c127&scoped=true&"
import script from "./DetailStock.vue?vue&type=script&lang=js&"
export * from "./DetailStock.vue?vue&type=script&lang=js&"
import style0 from "./DetailStock.vue?vue&type=style&index=0&id=7646c127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7646c127",
  null
  
)

export default component.exports